export default "__VITE_ASSET__CRf$0VCL__"